import { AppColors } from '@cmbg-traky-web/design-system';
import { CSSProperties } from 'react';

type PageStyles = {
  search__container: CSSProperties;
  stores__container: CSSProperties;
  stores__title: CSSProperties;
  stores__dropdownTitle: CSSProperties;
  statusCardGroup: CSSProperties;
  searchActions__container: CSSProperties;
  storeSelector__dropdown: CSSProperties;
  deliveryPlanTag: CSSProperties;
  deliveryPlanCloseIcon: CSSProperties;
  optionContainer: CSSProperties;
  optionContainerSelected: CSSProperties;
  optionCheckbox: CSSProperties;
  optionCheckboxSelected: CSSProperties;
};

const styles: PageStyles = {
  search__container: {
    borderRadius: '8px',
    margin: 'auto',
    padding: '24px',
    backgroundColor: AppColors.VA.NEUTRALS.WHITE,
    boxShadow: '0px 1px 8px 0px rgba(21, 34, 50, 0.08)'
  },
  stores__container: {
    padding: '114px 331px 24px 331px',
    height: '100%'
  },
  stores__title: {
    color: AppColors.VA.PRIMARY._50_,
    textAlign: 'center',
    marginBottom: '30px'
  },
  stores__dropdownTitle: {
    color: AppColors.VA.NEUTRALS._90_,
    marginBottom: '8px'
  },
  statusCardGroup: {
    marginBottom: '24px'
  },
  searchActions__container: {
    display: 'flex',
    justifyContent: 'start',
    marginBottom: '24px',
    alignItems: 'center',
    gap: '24px'
  },
  storeSelector__dropdown: {
    width: '247px',
    minWidth: '247px'
  },
  deliveryPlanTag: {
    margin: '2px',
    borderRadius: '5px',
    padding: '4px 8px',
    fontSize: '12px',
    backgroundColor: AppColors.VA.NEUTRALS._30_,
    color: AppColors.VA.NEUTRALS._90_,
    border: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px'
  },
  deliveryPlanCloseIcon: {
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    opacity: 0.8,
    transition: 'opacity 0.2s',
    color: AppColors.VA.NEUTRALS._50_
  },
  optionContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 0'
  },
  optionContainerSelected: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 0',
    backgroundColor: AppColors.VA.NEUTRALS._10_
  },
  optionCheckbox: {
    marginRight: 8,
    borderRadius: 2
  },
  optionCheckboxSelected: {
    marginRight: 8,
    borderRadius: 2,
    accentColor: AppColors.VA.NEUTRALS._10_
  }
};

export default styles;
